<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        02.12
        <br>2020
      </span>
      <span class="tiel">【新华社】凌晨三点，是谁在开启温暖的“抗疫食堂”？</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        <p>新华社长沙2月11日电 题：凌晨三点，是谁在开启温暖的“抗疫食堂”？</p>
        <p>新华社记者周楠</p>
        <!-- <br> -->
      </div>
      <div class="tet-js">
        <p>凌晨三点，闹铃响起，刘赞快速起床，收拾一番，戴上口罩，开车出门，准备开启今天的“抗疫食堂”。他是生鲜电商平台美菜网长沙分公司的一名送菜司机，每天负责把生鲜食品送到消费者家里。</p>
        <br>
        <p>窗外夜色如墨。摇下车窗，让寒风吹进来，驱走睡意，是刘赞每天出发时的常规操作。这名35岁的男子从春节开始值班，已经连续高强度工作半个多月。</p>
        <br>
        <p>半个小时后，他到达了公司位于长沙市望城区的生鲜储运中心，清点核对好要配送的货物，按照配送顺序在车上放置好，花了将近两个小时。放在最外面的几大袋肉食蔬菜，外表干净，摆放整齐。临出发，他又打开袋子看了看，嘴里嘀咕着，再次清点数目。</p>
        <br>
        <p>这几个大袋子里的菜要送到长沙市第四医院，同事们开玩笑说这是他的VIP。近日，长沙的新冠肺炎疫情防控形势严峻，长沙市第四医院作为新冠肺炎定点救治医院，春节期间的食材需求量比往年增长许多，医院食堂每天就餐人数约800人。但春节放假，加上疫情防控需要，大量农贸市场关闭，不少食材配送企业也歇业，焦急的长沙市第四医院食堂负责人联系到刘赞所在的企业，确保了春节期间的食材供应。</p>
        <br>
        <p>尽管从仓库到长沙市第四医院的路上会经过许多老客户，但刘赞从第一天就决定要把菜最早送到医院。“医院现在是防疫的战场，我们每一个人都要出一份力，给他们最大的支持，我每天起早一点，也不耽误老客户的时间。”</p>
        <br>
        <p>疫情紧张，车流量大大减少，刘赞很快就到了长沙市第四医院。进门，报身份，量体温，来到了食堂后门。“现在要求无接触式送菜，我把菜放在后门，放好后打电话给他们，他们再搬进去。”</p>
        <br>
        <p>双方虽然不能直接接触，但相互间的信任和感激与日俱增。长沙市第四医院食堂采购负责人贺赛男说：“小伙子非常负责，送菜送得早，每次都放得特别整齐，连菜叶子都不会压坏。”</p>
        <br>
        <p>有了稳定的食材保障，春节期间长沙市第四医院的食堂给医护人员、病人和家属们提供了充足和可口的饭菜。“我们的医护人员冲锋在一线，后勤保障必须要跟得上，我们菜品丰富，做好保温，大家都说我们这里是温暖的‘抗疫食堂’。”</p>
        <br>
        <p>抗疫前线，危险，紧张，医护人员们迎难而上，英勇奋战。抗疫的大后方，无数像刘赞一样的普通人，兢兢业业做好自己的本职工作，为前线提供最强大的支援。</p>
        <br>
        <p>送完菜，穿过大院，记者问刘赞，每天都要来这个新冠肺炎定点救治医院，怕不怕被传染？“说实话，一开始确实担心，但想想医生护士都在病房里面，自己只是在大院停留半个小时，就不怕了。”刘赞说，“而且，大家都是社会的一分子，应该做好自己的事，为这次防疫作出贡献，体现自己的价值。”</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
